<script>
export default {
  name: "IconGreenInfo",
  props: {
    iconClass: {
      type: [String, Array, Object],
      default: "icon-primary-fill"
    }
  }
};
</script>

<template>
  <svg width="22" height="22" viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg">
    <g
      transform="translate(1 1)"
      fill="none"
      fill-rule="evenodd"
      stroke="none"
      stroke-width="1"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <circle stroke-width="1.7" :class="iconClass" cx="10" cy="10" r="10" />
      <path stroke-width="2" stroke="#FFF" d="M10 14v-4M10 6h.01" />
    </g>
  </svg>
</template>
